(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
    		'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsController', reports);

  reports.$inject = ['$scope', '$http', '$timeout'];

  function reports ($scope, $http, $timeout) {
    	var vm = this;
    	$scope.vm = vm;

    Chart.defaults.global.colours = [
      {
        fillColor: 'rgba(70,191,189,0.2)',
        strokeColor: 'rgba(70,191,189,1)',
        pointColor: 'rgba(70,191,189,1)',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(70,191,189,0.8)'
      },
      {
        fillColor: 'rgba(151,187,205,0.2)',
        strokeColor: 'rgba(151,187,205,1)',
        pointColor: 'rgba(151,187,205,1)',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(151,187,205,0.8)'
      },
      {
        fillColor: 'rgba(247,70,74,0.2)',
        strokeColor: 'rgba(247,70,74,1)',
        pointColor: 'rgba(247,70,74,1)',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(247,70,74,0.8)'
      }
    ];
    vm.graphs = {};
    vm.graphs.mensagens = {};
    vm.graphs.clientes = {};

    vm.graphs.mensagens.label = [];
    vm.graphs.mensagens.data = [];

	    vm.graphs.clientes.label = ['Atendidos por Operador', 'Totalmente Automáticos'];
	    vm.graphs.clientes.data = [];

	    vm.optionsTodas = {
	        maintainAspectRatio: true,
	        responsive: true
	    }

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    $http.get(apiUrl + '/polls')
      .then(function ({ data }) {
        vm.hasPoll = (data.length > 0);
      }, function ({ data }) { console.log(data) })
    vm.pollGraph = null;

    vm.filterPoll = function () {
      $http({
        url: apiUrl + '/polls/report',
        method: 'GET',
        params: { fromDate: vm.filters.fromDate, toDate: vm.filters.toDate }
      })
        .then(function ({ data }) {
          vm.pollGraph = {};

          vm.pollGraph.label = [];
          vm.pollGraph.data = [];

          vm.total_poll = 0;
          $timeout(function () {
            angular.forEach(data.possible_answers, function (answer) {
              vm.pollGraph.label.push(answer.value);
              vm.pollGraph.data.push(parseInt(answer.qty));
              vm.total_poll += parseInt(answer.qty);
            });
            vm.pollTable = data.possible_answers;
          }, 100);
        }, function ({ data }) { console.log(data) })
    };

    vm.refreshReport = function () {
      $http({
        url: apiUrl + '/reports',
        method: 'GET',
        params: { fromDate: vm.filters.fromDate, toDate: vm.filters.toDate }
      })
        .then(function ({ data }) {
          vm.reports = data;

          vm.total_messages = {
            qty: 0,
            received: 0,
            sent_operator: 0,
            sent_auto: 0
          };

          vm.graphs.mensagens.label = [];
          vm.graphs.mensagens.data = [];

          angular.forEach(data.sectors, function (sector) {
            var name = sector.sector_name;
            var qtde = sector.sent_auto + sector.sent_operator + sector.received;

            vm.graphs.mensagens.label.push(name);
            vm.graphs.mensagens.data.push(qtde);

            vm.total_messages.qty += sector.qty;
            vm.total_messages.received += sector.received;
            vm.total_messages.sent_operator += sector.sent_operator;
            vm.total_messages.sent_auto += sector.sent_auto;
          });
          vm.graphs.clientes.data = [ data.atendidos, data.nao_atendidos ];
        }, function ({ data }) { console.log(error) })
    }

    vm.toggleAllContactsFilter = function () {
      var all = vm.report_contacts_filters.all;
      vm.report_contacts_filters.name = all;
      vm.report_contacts_filters.date = all;
      vm.report_contacts_filters.number = all;
      vm.report_contacts_filters.status = all;
      vm.report_contacts_filters.sector = all;
      vm.report_contacts_filters.total_messages = all;
      vm.report_contacts_filters.channel = all;
    };
    vm.downloadContactReport = function () {
      var filters = {
        fromDate: vm.filters.fromDate,
        toDate: vm.filters.toDate,
        name: vm.report_contacts_filters.name,
        date: vm.report_contacts_filters.date,
        number: vm.report_contacts_filters.number,
        status: vm.report_contacts_filters.status,
        sector: vm.report_contacts_filters.sector,
        total_messages: vm.report_contacts_filters.total_messages,
        channel: vm.report_contacts_filters.channel
      };
      $http({ method: 'GET', url: apiUrl + '/reports-contacts', params: filters })
        .then(function ({ data }) {
          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' }); // Make sure it's not visible
          angular.element(document.body).append(anchor); // Attach to document

          anchor.attr({
            href: 'data:attachment/csv;charset=utf-8,' + encodeURI(data),
            target: '_blank',
            download: 'relatorio_mktzap.csv'
          })[0].click();

          anchor.remove();
        }, function ({ data }) { console.log(data) })
    };
    vm.report_contacts_filters = {};
    vm.refreshReport();
  }
})();
